// extracted by mini-css-extract-plugin
module.exports = {"group":"da51a739f7--group--LJyVd"};